import React from 'react';
import {pageBlockPropType} from '../../../propType/CustomPagePropType';

const CustomPageDetailContentHeader = (props) => {

  let {
    pageBlock
  } = props;

  const title = () => {
    return pageBlock.pageBlockTitle && pageBlock.pageBlockTitle.length>0?pageBlock.pageBlockTitle:pageBlock.pageBlockTypeCode;
  };

  return (
    <div>
      <h2 className="m_mHead customPage-pageBlock-title" data-pageblockid={pageBlock.pageBlockId}>{title()}</h2>
      {pageBlock.pageBlockDescriptionHtml &&
      <div className="txt tui-editor-contents clearfix" dangerouslySetInnerHTML={{__html:pageBlock.pageBlockDescriptionHtml}}></div>
      }
    </div>
  );
};

CustomPageDetailContentHeader.propTypes = {
  pageBlock: pageBlockPropType(),
};

export default CustomPageDetailContentHeader;
